import { AfterViewInit, Directive, ElementRef, EventEmitter, HostListener, Output } from "@angular/core";

@Directive({
    selector: "[gmapAutocomplete]"
})
export class GmapAutocompleteDirective implements AfterViewInit {

    autocompleteInput: string;
    queryWait: boolean;
    @Output() setAddress: EventEmitter<any> = new EventEmitter();

    constructor(
        private elementRef: ElementRef
    ) { }

    ngAfterViewInit() {
        this.getPlaceAutocomplete();
    }

    private getPlaceAutocomplete() {
        const autocomplete = new google.maps.places.Autocomplete(this.elementRef.nativeElement,
            {
                // componentRestrictions: { country: 'US' },
                types: ['address']  // 'establishment' / 'address' / 'geocode'
            });
        google.maps.event.addListener(autocomplete, 'place_changed', () => {
            const place = autocomplete.getPlace();
            this.invokeEvent(place);
        });
    }

    invokeEvent(place: Object) {
        this.setAddress.emit(place);
    }

}